import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "email-indicator" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResendEmail = _resolveComponent("ResendEmail")!
  const _component_MessageLayout = _resolveComponent("MessageLayout")!

  return (_openBlock(), _createBlock(_component_MessageLayout, {
    image: "./email-sent.svg",
    altText: "email sent",
    title: "Check your email"
  }, {
    action: _withCtx(() => [
      _createVNode(_component_ResendEmail)
    ]),
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createTextVNode(" An email has been sent to ")),
      _createElementVNode("strong", _hoisted_1, _toDisplayString(_ctx.email), 1),
      _cache[1] || (_cache[1] = _createElementVNode("p", null, " Please follow the instructions in the verification email to finish creating your Nobl9 account. ", -1))
    ]),
    _: 1,
    __: [0,1]
  }))
}